export function createSpacing(options) {
    if (typeof options === "function")
        return options;
    const resolved = (...values) => {
        return values
            .map((v) => typeof v === "number" ? `${v * (options ?? 8)}px` : v)
            .join(" ");
    };
    return resolved;
}
export default createSpacing;
